import * as React from 'react';
import { DayPicker } from 'react-day-picker';

import { cn } from '@/lib/utils';

export type CalendarProps = React.ComponentProps<typeof DayPicker>;

export function Calendar({ className, classNames, ...props }: CalendarProps) {
  const today = new Date();

  return (
    <DayPicker
      showOutsideDays={false}
      className={cn('p-4', className)}
      disabled={[{ after: today }, ...(Array.isArray(props.disabled) ? props.disabled : props.disabled ? [props.disabled] : [])]}
      classNames={{
        months: 'flex flex-col sm:flex-row space-y-4 sm:space-x-6 sm:space-y-0',
        month: 'space-y-4 flex flex-col',
        month_caption: 'flex justify-center pt-1 items-center mb-1',
        month_grid: 'w-full border-collapse space-y-1',
        nav: 'flex items-center justify-center gap-2 order-3 mt-2',
        button_previous: cn(
          'h-8 w-8 bg-transparent p-0 hover:bg-gray-100 rounded-md transition-colors',
          'inline-flex items-center justify-center',
          'text-gray-700 hover:text-gray-900'
        ),
        button_next: cn(
          'h-8 w-8 bg-transparent p-0 hover:bg-gray-100 rounded-md transition-colors',
          'inline-flex items-center justify-center',
          'text-gray-700 hover:text-gray-900'
        ),
        weekdays: 'flex mb-1 justify-center',
        weekday: 'text-gray-700 w-10 font-semibold text-xs uppercase tracking-wider text-center',
        week: 'flex w-full mt-0.5 justify-center',
        day: cn(
          'relative p-0 text-center text-sm w-10 flex items-center justify-center'
        ),
        day_button: cn(
          'h-10 w-10 p-0 font-medium inline-flex items-center justify-center',
          'hover:bg-gray-50 hover:text-gray-900 transition-all duration-150',
          'focus:outline-none focus:ring-2 focus:ring-[#290BD9] focus:ring-offset-2',
          'rounded-md cursor-pointer'
        ),
        selected: cn(
          'bg-[#290BD9] text-white hover:bg-[#2309C5] hover:text-white',
          'font-semibold rounded-md',
          '[&_.day_button]:bg-[#290BD9] [&_.day_button]:text-white'
        ),
        today: cn(
          'font-bold text-[#290BD9]'
        ),
        outside: 'text-gray-400 opacity-50 hover:opacity-100',
        disabled: 'text-gray-300 opacity-50 cursor-not-allowed hover:bg-transparent',
        range_start: cn(
          'bg-[#290BD9] text-white hover:bg-[#2309C5]',
          'rounded-md font-semibold'
        ),
        range_end: cn(
          'bg-[#290BD9] text-white hover:bg-[#2309C5]',
          'rounded-md font-semibold'
        ),
        range_middle: cn(
          'bg-transparent text-gray-900 hover:bg-gray-100',
          'rounded-none font-normal'
        ),
        hidden: 'invisible',
        chevron: 'h-4 w-4',
        ...classNames,
      }}
      {...props}
    />
  );
}
